import { useEffect, useRef, useState } from "react";
import {
  DragIcon,
  DragIcon2,
  IncomingCallIcon,
  RingingIcon,
  TableSortIconDownArrow,
  Talkingicon,
} from "../../../utils/icons/defaultIcons";
import FadeIn from "react-fade-in";
import ComponentMap from "../../../atom/componentmap";
import Table from "../../../atom/table";
import { getENVData } from "../../../config/environment";
import { getDisplayGroupById, getToken } from "../../../services/api";
import { useSelector } from "react-redux";
import {
  addChildrensToMapData,
  secondsToHHMMSS,
} from "../../../services/utilities";
import { Backdrop } from "@mui/material";
import Lottiefy from "../../../atom/lottie/lottie";
import * as loaderLottie from "../../../utils/lottie/loaderLottie.json";
import ThemedButton from "../../../atom/ThemedButton/themedButton";
import TableTopBar from "../../modal/tableTopBar";
import { WidthProvider, Responsive } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import CustomTooltip from "../../../atom/customTooltip";
// const GridLayout = WidthProvider(Responsive);
const GridLayout = WidthProvider(
  Responsive,
) as unknown as React.ComponentType<any>;

function WallboardCopy() {
  const wallboardLaunchData = useSelector(
    (state: any) => state.wallboardSettingsData.wallb_data,
  );

  // Define grid layout
  const layouts = {
    lg: [
      { i: "incoming", x: 0, y: 0, w: 1, h: 1.1 },
      { i: "outgoing", x: 1, y: 0, w: 1, h: 1.1 },
      { i: "users", x: 0, y: 1.1, w: 2, h: 1.4 },
      { i: "groups", x: 0, y: 2.5, w: 2, h: 1.4 },
    ],
    md: [
      { i: "incoming", x: 0, y: 0, w: 1, h: 1.5 },
      { i: "outgoing", x: 0, y: 1.5, w: 1, h: 1.5 },
      { i: "users", x: 0, y: 3.0, w: 1, h: 1.8 },
      { i: "groups", x: 0, y: 4.8, w: 1, h: 2.2 },
    ],
  };
  const modalRef = useRef<HTMLInputElement>(null);
  const [hideDropdown, setHideDropdown] = useState<boolean>(false);
  const [noResultsFound, setNoResultsFound] = useState<boolean>(true);
  const [wallboardData, setWallboardData] = useState<any>([]);
  const [incStatsData, setIncStatsData] = useState<any>({});
  const [outStatsData, setOutStatsData] = useState<any>({});
  const [groupCallData, setGroupCallData] = useState<any>({
    ringing: 0,
    talking: 0,
  });
  const [groupSelected, setGroupSelected] = useState<boolean>(false);
  const [selectedGroupId, setSelectedGroupId] = useState<string>("");

  const isComponentMounted = useRef(false); // To track if the component is mounted
  const socketRef = useRef<WebSocket | null>(null);
  const accessToken = useSelector((state: any) => state.auth.token);
  const [loader, setLoader] = useState<boolean>(false);
  const [sort, setSort] = useState<any>({
    key: "extension",
    order: "ASC",
  });
  const sortRef = useRef<any>({
    key: "extension",
    order: "ASC",
  });
  const [groupSort, setGroupSort] = useState<any>({
    key: "extension",
    order: "ASC",
  });
  const groupSortRef = useRef<any>({
    key: "extension",
    order: "ASC",
  });
  const [usersTableTitles, setUsersTableTitles] = useState<any>([
    {
      key: "extension",
      title: "Extension",
      hide: {
        status: true,
        default: true,
      },
      sort: { direction: "asc", active: true },
      icon: <TableSortIconDownArrow />,
    },
    {
      key: "name",
      title: "Name",
      hide: {
        status: true,
        default: true,
      },
      sort: { direction: "asc", active: false },
      icon: <TableSortIconDownArrow />,
    },
    {
      key: "inbound_calls_offered",
      title: "In Calls Offered",
      hide: {
        status: false,
        default: false,
      },
      sort: { direction: "asc", active: false },
      icon: <TableSortIconDownArrow />,
    },
    {
      key: "inbound_calls_answered",
      title: "In Calls Ans",
      hide: {
        status: true,
        default: false,
      },
      sort: { direction: "asc", active: false },
      icon: <TableSortIconDownArrow />,
    },
    {
      key: "outbound_calls_made",
      title: "Out Calls Made",
      hide: {
        status: false,
        default: false,
      },
      sort: { direction: "asc", active: false },
      icon: <TableSortIconDownArrow />,
    },
    {
      key: "outbound_calls_answered",
      title: "Out Calls Ans",
      hide: {
        status: true,
        default: false,
      },
      sort: { direction: "asc", active: false },
      icon: <TableSortIconDownArrow />,
    },

    {
      key: "internal_calls",
      title: "Internal Calls",
      hide: {
        status: true,
        default: false,
      },
      sort: { direction: "asc", active: false },
      icon: <TableSortIconDownArrow />,
    },
    {
      key: "internal_calls_answered",
      title: "Internal Calls Ans",
      hide: {
        status: true,
        default: false,
      },
      sort: { direction: "asc", active: false },
      icon: <TableSortIconDownArrow />,
    },
    {
      key: "transferred_in",
      title: "Transferred In",
      hide: {
        status: false,
        default: false,
      },
      sort: { direction: "asc", active: false },
      icon: <TableSortIconDownArrow />,
    },
    {
      key: "transferred_out",
      title: "Transferred Out",
      hide: {
        status: false,
        default: false,
      },
      sort: { direction: "asc", active: false },
      icon: <TableSortIconDownArrow />,
    },
    {
      key: "talk_time",
      title: "Talk Time",
      hide: {
        status: true,
        default: false,
      },
      sort: { direction: "asc", active: false },
      icon: <TableSortIconDownArrow />,
    },
    {
      key: "average_talk_time",
      title: "Avg Talk Time",
      hide: {
        status: true,
        default: false,
      },
      sort: { direction: "asc", active: false },
      icon: <TableSortIconDownArrow />,
    },
    {
      key: "status",
      title: "Status",
      type: "currentStatus",
      class: "text-center",
      // hide: {
      //   status: true,
      //   default: true,
      // },
      sort: { direction: "asc", active: false },
      icon: <TableSortIconDownArrow />,
    },
  ]);

  const [usersTableData, setUsersTableData] = useState<any>([]);

  const [groupsTableTitles, setGroupsTableTitles] = useState<any>([
    {
      key: "extension",
      title: "Extension",
      sort: { direction: "asc", active: false },
      icon: <TableSortIconDownArrow />,
    },
    {
      key: "first_name",
      title: "First Name",
      sort: { direction: "asc", active: false },
      icon: <TableSortIconDownArrow />,
    },
    {
      key: "last_name",
      title: "Last Name",
      sort: { direction: "asc", active: false },
      icon: <TableSortIconDownArrow />,
    },
    {
      key: "status",
      title: "Status",
      type: "currentStatus",
      sort: { direction: "asc", active: false },
      icon: <TableSortIconDownArrow />,
    },
  ]);

  const [groupsData, setGroupsData] = useState<any>([]);
  const [groupsTableData, setGroupsTableData] = useState<any>([]);

  const incStatisticsTableTitles = [
    { key: "name", title: "", icon: <TableSortIconDownArrow /> },
    {
      key: "total_talk_time",
      title: "Total",
      icon: <TableSortIconDownArrow />,
    },
    {
      key: "avg_talk_time",
      title: "Average",
      icon: <TableSortIconDownArrow />,
    },
    {
      key: "max_talk_time",
      title: "Maximum",
      icon: <TableSortIconDownArrow />,
    },
  ];

  const [incStatisticsTableData, setIncStatisticsTableData] = useState<any>([]);

  const outStatisticsTableTitles = [
    { key: "name", title: "", icon: <TableSortIconDownArrow /> },
    {
      key: "total_talk_time",
      title: "Total",
      icon: <TableSortIconDownArrow />,
    },
    {
      key: "avg_talk_time",
      title: "Average",
      icon: <TableSortIconDownArrow />,
    },
    {
      key: "max_talk_time",
      title: "Maximum",
      icon: <TableSortIconDownArrow />,
    },
  ];

  const [outStatisticsTableData, setOutStatisticsTableData] = useState<any>([]);

  const [groupsDropdownData, setGroupsDropdownData] = useState<any>([
    {
      title: "Select Group",
      name: "name",
      value: "",
      type: "dropdown",
      layout: "6",
      displayProps: { label: "name", value: "uuid" },
      childrens: [],
      required: true,
      errormessage: "Group is Required",
    },
  ]);

  useEffect(() => {
    const local: any = window.sessionStorage.getItem("liveUsers") || null;
    const result = JSON.parse(local);
    // var result = cookies.get("lagacyCDRTableTitle");
    // debugger
    if (result) {
      var data = [...usersTableTitles];
      data.map((node: any) => {
        if (result[node.key] !== undefined) {
          if (node.hide) {
            node.hide.status = result[node.key];
          }
        }
      });
      setUsersTableTitles(data);
    }
    const handleClickOutside = (event: any) => {
      if (modalRef.current && !modalRef.current.contains!(event.target)) {
        setHideDropdown(false);
      }
    };

    // Attach the event listener to the document
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up the event listener when the component is unmounted
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [hideDropdown]);

  const [hideDropdownValues, setHideDropdownValues] = useState<any>([
    { name: "Direction", checked: false },
    { name: "Orginal Extension", checked: false },
    { name: "Transfer Extension", checked: false },
    { name: "Groups", checked: false },
    { name: "Call Organization", checked: false },
    { name: "Call Destination", checked: false },
    { name: "Start Time", checked: false },
    { name: "End Time", checked: false },
    { name: "Total Time", checked: false },
  ]);

  const [wallBoardData, setWallBoardData] = useState<any>([
    {
      title: "Last Hours",
      name: "lastHours",
      value: "",
      type: "dropdown",
      displayProps: { label: "label", value: "uuid" },
      childrens: [
        { label: "Last Hour", value: "Last hour" },
        { label: "Last 2 Hours", value: "Last 2 hours" },
      ],
    },
  ]);

  const objectsToArray = (data: any, item: string) => {
    if (item === "incoming") {
      const wait = {
        name: "Wait",
        total_talk_time: secondsToHHMMSS(data?.total_wait_time),
        avg_talk_time: secondsToHHMMSS(data?.avg_wait_time),
        max_talk_time: secondsToHHMMSS(data?.max_wait_time),
      };
      const talk = {
        name: "Talk",
        total_talk_time: secondsToHHMMSS(data?.total_talk_time),
        avg_talk_time: secondsToHHMMSS(data?.avg_talk_time),
        max_talk_time: secondsToHHMMSS(data?.max_talk_time),
      };

      setIncStatisticsTableData([wait, talk]);
    }

    if (item === "outgoing") {
      const wait = {
        // secondsToHHMMSS
        name: "Wait",
        total_talk_time: secondsToHHMMSS(data?.total_wait_time),
        avg_talk_time: secondsToHHMMSS(data?.avg_wait_time),
        max_talk_time: secondsToHHMMSS(data?.max_wait_time),
      };
      const talk = {
        name: "Talk",
        total_talk_time: secondsToHHMMSS(data?.total_talk_time),
        avg_talk_time: secondsToHHMMSS(data?.avg_talk_time),
        max_talk_time: secondsToHHMMSS(data?.max_talk_time),
      };

      setOutStatisticsTableData([wait, talk]);
    }
  };

  const listGroups = () => {
    setLoader(true);
    getDisplayGroupById(
      wallboardLaunchData[0]?.value,
      wallboardLaunchData[1]?.value?.value === undefined
        ? "1"
        : wallboardLaunchData[1]?.value?.value,
    ).then((result: any) => {
      if (!result.success) {
        setLoader(false);
      } else {
        setLoader(false);

        setWallboardData(result?.data?.data);
        const filteredDisplayGroup = result?.data?.data?.call_groups_l?.filter(
          (node: any) => node.is_selected === true,
        );
        setGroupsDropdownData(
          addChildrensToMapData(
            [...groupsDropdownData],
            filteredDisplayGroup,
            "name",
          ),
        );
      }
    });
  };

  const connectWebSocket = () => {
    const wssUrl = getENVData().baseURL.replace("https", "wss");

    const url = `${wssUrl}events/liveboard/tenants/${getToken()}/ws/wallboard/${
      wallboardLaunchData[0]?.value
    }/${wallboardLaunchData[1]?.value.value ?? "1"}?token=${accessToken}`;
    if (!socketRef.current) {
      socketRef.current = new WebSocket(url);
      setLoader(true);
      socketRef.current.addEventListener("open", (event) => {
        console.log("Connected to WebSocket", event);
        setLoader(false);
      });

      socketRef.current.addEventListener("message", (event) => {
        console.log("Message received from server:", event);
        const data = JSON.parse(event.data);

        setLoader(false);
        // new added
        const wsData = JSON.parse(event.data);

        setUsersTableData((prev: any) => {
          // merge live updates
          const updated = prev.map((item: any) =>
            item.uuid === wsData.uuid ? { ...item, ...wsData } : item,
          );

          // re-apply current sorting
          return sortUsers(updated, sortRef.current);
        });
        // end new added

        // Statistics
        if (
          data?.event === "incoming_statistics.create" ||
          data?.event === "incoming_statistics.update"
        ) {
          console.log("data", data);
          setIncStatsData(data);
          objectsToArray(data, "incoming");
        }
        if (
          data?.event === "outgoing_statistics.create" ||
          data?.event === "outgoing_statistics.update"
        ) {
          setOutStatsData(data);
          objectsToArray(data, "outgoing");
        }

        // Users
        if (data?.event === "users.create") {
          data.talk_time = secondsToHHMMSS(data?.talk_time);
          data.average_talk_time = secondsToHHMMSS(data?.average_talk_time);
          data.status = !data?.is_logged_in
            ? "Logged Out"
            : data?.ph_state === "idle"
              ? "Available"
              : "Busy";
          setUsersTableData((prevEvents: any) =>
            sortUsers([...prevEvents, data], sortRef.current),
          );
        }
        if (data?.event === "users.update") {
          data.talk_time = secondsToHHMMSS(data?.talk_time);
          data.average_talk_time = secondsToHHMMSS(data?.average_talk_time);
          data.status = !data?.is_logged_in
            ? "Logged Out"
            : data?.ph_state === "idle"
              ? "Available"
              : "Busy";
          setUsersTableData((prevEvents: any) =>
            sortUsers(
              prevEvents.map((event: any) =>
                event.uuid === data.uuid ? { ...event, ...data } : event,
              ),
              sortRef.current,
            ),
          );
        }
        if (data.event === "call_group.create") {
          setGroupsData((prevGroups: any) => [
            ...prevGroups,
            { ...data, members: [] }, // Add new group with empty members
          ]);
          console.log("data.event.create", data);
          if (selectedGroupId === data?.uuid) {
            setGroupCallData({
              ringing: data?.ringing,
              talking: data?.talking,
            });
          }
        }

        if (data.event === "call_group.update") {
          // console.log("data.event.updateeee", data, selectedGroupId);
          console.log("selectedGroupId22", selectedGroupId);

          setGroupsData((prevGroups: any) =>
            prevGroups.map((group: any) =>
              group.uuid === data.uuid
                ? { ...group, ...data } // Update the matching group with new data
                : group,
            ),
          );

          if (selectedGroupId === data?.uuid) {
            setGroupCallData({
              ringing: data?.ringing,
              talking: data?.talking,
            });
          }
          const value = { name: data.uuid };

          onSelectGroup(value);
        }

        if (data.event === "call_group_member.create") {
          data.status = !data?.is_logged_in
            ? "Logged Out"
            : data?.ph_state === "idle"
              ? "Available"
              : "Busy";
          setGroupsData((prevGroups: any) =>
            prevGroups?.map((group: any) =>
              group.uuid === data.grp_uuid
                ? { ...group, members: [...group.members, data] } // Add member to matching group
                : group,
            ),
          );
        }

        if (data.event === "call_group_member.update") {
          data.status = !data?.is_logged_in
            ? "Logged Out"
            : data?.ph_state === "idle"
              ? "Available"
              : "Busy";

          const currentGroups = groupsDataRef.current; // always the latest!

          const updatedGroupsData = currentGroups.map((group: any) => {
            if (group.uuid !== data.grp_uuid) return group;

            const updatedMembers = group.members.map((member: any) =>
              member.uuid === data.uuid ? { ...member, ...data } : member,
            );

            return { ...group, members: updatedMembers };
          });

          setGroupsData(updatedGroupsData);
          onSelectGroup(groupsDropdownData[0]?.value, updatedGroupsData);
        }
      });

      socketRef.current.addEventListener("close", (e: Event) => {
        setLoader(false);
        if (isComponentMounted.current) {
          console.log("WebSocket connection closed", socketRef.current, e);
          console.log("WebSocket connection closed Attempting to reconnect...");
          socketRef.current = null;
          reconnectWebSocket();
        } else {
          console.log(
            "WebSocket closed and no reconnect as component is unmounted.",
          );
        }
      });
      socketRef.current.addEventListener("error", (error) => {
        setLoader(false);
        console.error("WebSocket encountered an error:", error);
        if (socketRef.current) {
          socketRef.current.close(1000, "Normal closure"); // Close the connection on error
        }
      });
    }
  };

  const reconnectWebSocket = () => {
    if (!isComponentMounted.current) return; // Stop reconnecting if the component is unmounted
    setTimeout(() => {
      console.log("Reconnecting WebSocket...");
      setUsersTableData([]); // Clear users table data on reconnect
      setGroupsData([]); // Clear groups data on reconnect
      connectWebSocket(); // Retry connection
      setUsersTableData([]); // Clear users table data on reconnect
      setGroupsData([]); // Clear groups data on reconnect
    }, 3000); // Retry after 3 seconds
  };

  useEffect(() => {
    listGroups();

    isComponentMounted.current = true; // Component is mounted
    if (socketRef.current) {
      socketRef.current.close(1000, "Normal closure");
      console.log("WebSocket closed during cleanup");
    }
    setTimeout(connectWebSocket, 100);
    return () => {
      isComponentMounted.current = false; // Component is mounted
      if (socketRef.current) {
        socketRef.current.close(1000, "Normal closure");
        console.log("WebSocket closed during cleanup");
        // setTimeout(connectWebSocket, 3000);
      }
      console.log("socketRef", socketRef);
    };
  }, []);
  const outStatsdisplayOrder = [
    "calls_made",
    "calls_answered",
    "response_level",
  ];

  const incStatsdisplayOrder = [
    "calls_received",
    "calls_answered",
    "service_level",
  ];

  const onSelectGroup = (data: any, updatedGroupsData?: any) => {
    let newGroupsData: any;
    let id: any;

    if (groupsDropdownData[0]?.value) {
      setGroupSelected(true);
    }
    if (updatedGroupsData === undefined) {
      newGroupsData = [...groupsData];
      id = data?.name;
      setSelectedGroupId(id);
    } else {
      newGroupsData = updatedGroupsData;
      id = data;
      setSelectedGroupId(id);
    }
    // console.log("newGroupsData", newGroupsData, "id", id);
    const filter = newGroupsData?.filter((node: any) => id === node.uuid);

    if (filter?.length !== 0) {
      // console.log("filter", filter[0], "updatedGroupsData", updatedGroupsData);
      if (updatedGroupsData === undefined) {
        setGroupCallData({
          ringing: filter[0]?.ringing,
          talking: filter[0]?.talking,
        });
      } else {
        setGroupCallData({
          ringing: filter[0]?.ringing,
          talking: filter[0]?.talking,
        });
      }

      setNoResultsFound(false);
      const sortedMembers = sortUsers(
        filter[0]?.members || [],
        groupSortRef.current,
      );
      setGroupsTableData(sortedMembers);
    } else {
      setNoResultsFound(true);
      setGroupsTableData([]);
      setGroupCallData({
        ringing: 0,
        talking: 0,
      });
    }
  };

  const handleTableTitle = (data: any) => {
    setUsersTableTitles(data);
    var status: any = {};
    data
      .filter((node: any) => node?.hide?.status !== undefined)
      .map((node: any) => {
        status[node.key] = node.hide.status;
      });
    window.sessionStorage.setItem("liveUsers", JSON.stringify(status));
    // cookies.set("lagacyCDRTableTitle", JSON.stringify(status), {
    //   path: "/",
    // });
  };

  const groupsDataRef = useRef<any[]>([]);

  const onHandleSort = (key: any, order: string) => {
    setSort({ key: key.key, order });

    // Immediately apply sorting
    setUsersTableData((prev: any) => sortUsers(prev, { key: key.key, order }));
  };
  const onHandleGroupSort = (key: any, order: string) => {
    setGroupSort({ key: key.key, order });

    // Immediately apply sorting
    setGroupsTableData((prev: any) => sortUsers(prev, { key: key.key, order }));
  };

  const sortUsers = (data: any[], sort: { key: string; order: string }) => {
    return [...data].sort((a, b) => {
      const x = a[sort.key];
      const y = b[sort.key];

      if (x === y) return 0;

      if (sort.order === "ASC") {
        return x > y ? 1 : -1;
      } else {
        return x < y ? 1 : -1;
      }
    });
  };

  // Keep the ref in sync
  useEffect(() => {
    groupsDataRef.current = groupsData;
    sortRef.current = sort;
    groupSortRef.current = groupSort;
  }, [groupsData, sort, groupSort]);

  return (
    <div data-testid="wallboard" className="">
      {/*Top Bar  */}
      <Backdrop className="!z-[99999999999]" open={loader}>
        <Lottiefy loop={true} json={loaderLottie} height={100} width={100} />
      </Backdrop>
      <div className="ml-[-12px] h-full">
        <div className="pt-3 px-3">
          <div className="bg-[white] h-[60px]  rounded-md">
            <div className="flex justify-between h-full px-4">
              {!loader && (
                <div className=" font-bold flex items-center justify-between text-[18px] -mt-0.5 w-full">
                  <div>{wallboardData?.name}</div>
                  <div>
                    Last{" "}
                    {wallboardData?.interval === "1"
                      ? ""
                      : wallboardData?.interval}{" "}
                    {wallboardData?.interval === "1" ? "Hour" : "Hours"}
                  </div>
                </div>
              )}
              {/* <div className="smallPicker text-right w-[200px] mt-0.5">
                <ComponentMap data={wallBoardData} setData={setWallBoardData} />
              </div> */}
            </div>
          </div>
        </div>
      </div>
      {/*  */}

      {/* Body */}
      <div className="h-[calc(100vh-195px)] lg:w-[calc(100vw-126px)] w-[calc(100vw-90px)] mt-2 rounded-md overflow-y-auto overflow-x-hidden no-scrollbar">
        <GridLayout
          className="layout"
          layouts={layouts} // Responsive expects layouts object
          cols={{ lg: 2, md: 1, sm: 1, xs: 1, xxs: 1 }}
          rowHeight={400}
          draggableHandle=".drag-handle"
        >
          {/* Incoming Statistics */}
          <div key="incoming" className="bg-[white] rounded-md p-3 space-y-2 overflow-y-auto no-scrollbar">
            <div className="drag-handle cursor-move">
              <CustomTooltip title="Drag to Move">
                <DragIcon />
              </CustomTooltip>
            </div>
            <p className="font-bold text-[24px]">Incoming Statistics</p>

            {/* Boxes */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
              {incStatsdisplayOrder
                .filter((key: any) => key in incStatsData)
                .map((key: any, index: number) => {
                  const formattedKey = key
                    .replace(/_/g, " ")
                    .split(" ")
                    .map(
                      (word: any) =>
                        word.charAt(0).toUpperCase() + word.slice(1),
                    )
                    .join(" ");

                  return (
                    <div
                      key={key}
                      className={`${
                        index === 0
                          ? "bg-[#FFDBB2]"
                          : index === 1
                            ? "bg-[#D3D8FF]"
                            : "bg-[#FFF2CC]"
                      } rounded-lg text-left p-2 px-3`}
                    >
                      <p className="font-bold text-[24px] lg:text-[36px]">
                        {incStatsData[key]}
                        {key === "service_level" && "%"}
                      </p>
                      <p className="text-[18px] lg:text-[24px]">{formattedKey}</p>
                    </div>
                  );
                })}
            </div>

            <Table
              tableTitles={incStatisticsTableTitles}
              tableData={incStatisticsTableData}
              width={"w-[100%]"}
              scrollHeight={"max-h-[320px] overflow-y-auto"}
            />
          </div>

          {/* Outgoing Statistics */}
          <div key="outgoing" className="bg-[white] rounded-md p-3 space-y-2 overflow-y-auto no-scrollbar">
            <div className="drag-handle cursor-move">
              <CustomTooltip title="Drag to Move">
                <DragIcon />
              </CustomTooltip>
              <p className="font-bold text-[24px]">Outgoing Statistics</p>
            </div>

            {/* Boxes */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
              {outStatsdisplayOrder
                .filter((key: any) => key in outStatsData)
                .map((key: any, index: number) => {
                  const formattedKey = key
                    .replace(/_/g, " ")
                    .split(" ")
                    .map(
                      (word: any) =>
                        word.charAt(0).toUpperCase() + word.slice(1),
                    )
                    .join(" ");

                  return (
                    <div
                      key={key}
                      className={`${
                        index === 0
                          ? "bg-[#FFDBB2]"
                          : index === 1
                            ? "bg-[#D3D8FF]"
                            : "bg-[#FFF2CC]"
                      } rounded-lg text-left p-2 px-3`}
                    >
                      <p className="font-bold text-[24px] lg:text-[36px]">
                        {outStatsData[key]}
                        {key === "response_level" && "%"}
                      </p>
                      <p className="text-[18px] lg:text-[24px]">{formattedKey}</p>
                    </div>
                  );
                })}
            </div>

            <Table
              tableTitles={outStatisticsTableTitles}
              tableData={outStatisticsTableData}
              width={"w-[100%]"}
              scrollHeight={"max-h-[320px] overflow-y-auto"}
            />
          </div>

          {/* Users Table */}
          <div
            key="users"
            className="bg-[white] rounded-md p-3 w-full min-h-[280px] overflow-y-auto no-scrollbar"
          >
            <div className="drag-handle cursor-move  ml-4">
              <CustomTooltip title="Drag to Move">
                <DragIcon />
              </CustomTooltip>
            </div>
            <TableTopBar
              showDropdownValues={usersTableTitles}
              setHideDropdownValues={handleTableTitle}
              title={"Users"}
              titleClass={"text-[24px]"}
              search={false}
            />
            <Table
              tableTitles={usersTableTitles}
              setTableTitles={setUsersTableTitles}
              tableData={usersTableData}
              setTableData={setUsersTableData}
              resultNotFound={usersTableData?.length === 0}
              onHandleSort={onHandleSort}
              width={"w-[100%]"}
              scrollHeight={"h-auto min-h-[180px]"}
            />
          </div>

          {/* Groups Table */}
          <div
            key="groups"
            className="bg-[white] rounded-md p-3 w-full min-h-[280px] overflow-y-auto no-scrollbar"
          >
            <div className="drag-handle cursor-move ml-4">
              <CustomTooltip title="Drag to Move">
                <DragIcon />
              </CustomTooltip>
            </div>
            <div className="flex flex-col lg:flex-row lg:justify-stretch lg:space-x-4 space-y-2 lg:space-y-0 smallPicker px-2 sm:px-4">
              <p className="font-bold text-[24px] lg:shrink-0">Groups</p>

              <div className="w-full lg:w-[400px]">
                <ComponentMap
                  data={groupsDropdownData}
                  setData={setGroupsDropdownData}
                />
              </div>
              <div className="flex items-center lg:block">
                <ThemedButton
                  children={"Select"}
                  icon="custom"
                  theme="primary"
                  valiData={groupsDropdownData}
                  change={setGroupsDropdownData}
                  click={onSelectGroup}
                />
              </div>

              {groupSelected && (
                <div className="flex items-center justify-center">
                  <FadeIn>
                    <div className="flex items-center justify-center gap-x-3 sm:gap-x-6 font-bold text-sm sm:text-[18px]">
                      <div className="flex items-center gap-x-1 text-base sm:text-[21px]">
                        <RingingIcon /> Ringing: {groupCallData?.ringing}
                      </div>
                      <div className="flex items-center gap-x-1 text-base sm:text-[21px]">
                        <Talkingicon /> Talking: {groupCallData?.talking}
                      </div>
                    </div>
                  </FadeIn>
                </div>
              )}
            </div>

            <Table
              tableTitles={groupsTableTitles}
              setTableTitles={setGroupsTableTitles}
              tableData={groupsTableData}
              setTableData={setGroupsTableData}
              resultNotFound={noResultsFound}
              onHandleSort={onHandleGroupSort}
              width={"w-[100%]"}
              scrollHeight={"h-auto min-h-[180px]"}
            />
          </div>
        </GridLayout>
      </div>
      {/*  */}
    </div>
  );
}

export default WallboardCopy;
